<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
						<div class="d-flex justify-content-between w-100">
							<div class="d-flex">
								<div class="form-group mr-4">
									<input type="text" class="form-control" placeholder="Поиск" v-model="titleOrCode">
								</div>
							</div>
							<div>
								<h3>Общее количество: {{ totalCount }}</h3>
							</div>
						</div>

						<div class="table-responsive">
							<table class="table-striped table">
								<thead>
									<tr>
										<th>ID + Наименование</th>
										<th>ЕИ</th>
										<th>Относиться к категории</th>
										<th>Действие</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in products" :key="index">
										<td>{{ item.code }} {{ item.title }}</td>
										<td>{{ item.unit.title }}</td>
										<td>{{ item.category ? item.category.title : ''}}</td>
										<td>
											<a class="btn btn-warning cursor mr-4" @click="getProduct(item.id)">
												Изменить
											</a>
											<a href="javascript:void(0);" @click="deleteProduct(item.id)" class="btn btn-danger">Удалить</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="row d-flex justify-content-end">
							<paginate
								:page-count="pagination.count"
								:initial-page="0"
								:page-range="3"
								:margin-pages="2"
								:click-handler="getCurrentPage"
								:prev-text="'<'"
								:next-text="'>'"
								:container-class="'pagination'"
								:page-class="'page-item'"
								:page-link-class="'page-link-item'"
								:prev-class="'prev-pagination'"
								:prev-link-class="'prev-link-pagination'"
								:next-class="'next-pagination'"
								:next-link-class="'next-link-pagination'"
							></paginate>
						</div>

						 <div class="modal-mask" v-show="showProductModal" transition="modal">
								<div class="modal-wrapper">
										<div class="modal-container">
												<div class="modal-header">
												<slot name="header">Категория</slot>
												</div>

												<div class="modal-body">
														<div class="form-group">
																<label>Заголовок</label>
																<input type="text" class="form-control" v-model="product.title" />
														</div>
														<div class="form-group">
																<label>Код</label>
																<input type="text" class="form-control" v-model="product.code" />
														</div>
												
												</div>

												<div class="modal-footer">
												<slot name="footer">
														<button class="modal-button btn btn-danger" @click="closeCategoryModal()">Закрыть</button>
														<button class="modal-button btn btn-success" @click="productUpdate()">Изменить</button>
												</slot>
												</div>
										</div>
								</div>
						</div>
					</div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GET, DELETE, POST } from "../../shared/api";
export default {
  data() {
    return {
			showProductModal: false,
			product: {},
			products: [],
			filter: {},
			totalCount: 0,
			titleOrCode: "",
			pagination: {
				count: 0,
				perpage: 20
			},
			searchValue: ""
    };
  },
  methods: {
		openProductModal() {
			this.showProductModal = true;
		},
		closeCategoryModal() {
			this.showProductModal = false;
		},
    getData() {
      GET([], "/report/products", this, false).then(response => {
				this.products = response.data;
				this.totalCount = response.total;
				this.pagination.count = Math.ceil(response.total / this.pagination.perpage);
      });
		},
		getProduct(id) {
			for (var i = 0; i < this.products.length; i++) {
				if(this.products[i].id === id){
					this.product = this.products[i]
				}
			}
			this.openProductModal();
		},
		findProduct(value) {
			GET([], "/findProduct/" + this.searchValue, this, false).then(response => {
				this.products = response;
			});
		},
		productUpdate() {
			POST(this.product, "/productUpdate", this).then(response => {
				this.closeCategoryModal();
				if(this.searchValue && this.searchValue != undefined) {
					this.findProduct();
				} else {
					this.getData()
				}
			});
		},
		deleteProduct(id) {
			DELETE(id, "/product/", this).then(response => {
				this.findProduct();
			});
		},
		getCurrentPage(pageNumber) {
      GET(this.filter, "/report/products?page=" + pageNumber, this, false).then(response => {
				this.products = response.data;
				this.pagination.count = Math.ceil(response.total / this.pagination.perpage);
      });
    }
	},
	watch: {
		titleOrCode: function (value) {
			this.searchValue = value
			if(value.length != 0){
				this.findProduct(value);
			} else {
				this.getData();
			}
		},
	},
  mounted() {
    this.getData();
  }
};
</script>
